export default {"src":"/_next/static/media/certificate.90e6a77a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};